import client from '@/shared/apis/client'
import {
  LineSettings,
  LineSettingsUpdatePayload,
  LineSettingsVerifyResponse,
} from '../types/lineSettings'

export const getLineSettings = async (): Promise<LineSettings> => {
  const response = await client.get('/api/patient-messaging/line-settings/')
  return response.data
}

export const updateLineSettings = async (
  payload: LineSettingsUpdatePayload
): Promise<LineSettings> => {
  const response = await client.put(
    '/api/patient-messaging/line-settings/',
    payload
  )
  return response.data
}

export const verifyLineSettings =
  async (): Promise<LineSettingsVerifyResponse> => {
    const response = await client.post(
      '/api/patient-messaging/line-settings/verify/'
    )
    return response.data
  }
